import React, { useMemo } from 'react';

import {
  Box,
  FormLabel,
  Input as ChakraInput,
  FormErrorMessage,
} from '@chakra-ui/react';
import { chakra } from '@chakra-ui/system';
import { useController } from 'react-hook-form';

/**
 * Custom controlled & stylized Input component.
 */
const Input = chakra(
  ({
    control,
    name,
    label,
    error,
    floatingError,
    rules,
    defaultValue,
    ...rest
  }) => {
    const isFloatingError = useMemo(
      () => (floatingError === undefined ? true : floatingError),
      [floatingError]
    );

    const {
      field,
      fieldState: { isTouched, isDirty },
    } = useController({
      name,
      control,
      rules,
      defaultValue,
    });

    const isInputTouched = isDirty || isTouched || field.value;

    return (
      <Box position='relative'>
        <FormLabel
          color={isInputTouched ? 'whiteAlpha.500' : 'whiteAlpha.700'}
          fontSize={isInputTouched ? '12px' : '17px'}
          fontWeight='400'
          htmlFor={name}
          left={isInputTouched ? '3' : '4'}
          position='absolute'
          top={isInputTouched ? '6px' : '3'}
          transition='0.2s ease-out'
        >
          {label}
        </FormLabel>
        <ChakraInput
          id={name}
          paddingTop={isInputTouched ? '13px' : 0}
          sx={{
            '::-webkit-calendar-picker-indicator': { filter: 'invert(1)' },
          }}
          {...rest}
          {...field}
        />
        {error && isFloatingError ? (
          <FormErrorMessage
            bottom='4px'
            color='red.400'
            fontSize='sm'
            position='absolute'
            right='8px'
          >
            &#42; {error}
          </FormErrorMessage>
        ) : null}
      </Box>
    );
  }
);

export default Input;
